import { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import { TemplateType_Slug, Template } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useGetDefaultTemplate } from '@frontend/integrated-messaging';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { MessageTemplate, Text } from '@frontend/design-system';
import { useGetTemplateTags } from '../../hooks/use-get-template-tags';
import { useWaitlistShallowStore } from '../../stores';
import { defaultQuickFillTemplate } from '../../views/tray-content/send-messages/utils';
import { SelectTemplateButton } from './select-template-button';

export const WaitlistComposeMessage = () => {
  const { t } = useTranslation('schedule-quick-fill');
  const { selectedLocationIds } = useAppScopeStore();
  const getDefaultTemplate = useGetDefaultTemplate({ groupIds: selectedLocationIds });
  const defaultTemplate = getDefaultTemplate({ type: TemplateType_Slug.MANUAL_SCHEDULE_QUICK_FILL });
  const { templateTags } = useGetTemplateTags(selectedLocationIds);
  const { setSelectedTemplateString } = useWaitlistShallowStore('setSelectedTemplateString');

  const [selectedTemplate, setSelectedTemplate] = useState<Template>();

  useEffect(() => {
    setSelectedTemplateString(defaultTemplate?.templateString || defaultQuickFillTemplate);
  }, [defaultTemplate?.templateString, setSelectedTemplateString]);

  const handleSelectTemplate = (template: Template) => {
    setSelectedTemplate(template);
    setSelectedTemplateString(template.templateString);
  };

  return (
    <section>
      <header css={{ display: 'flex', gap: theme.spacing(1), alignItems: 'center', marginBottom: theme.spacing(1) }}>
        <Icon name='messaging' />
        <Text weight='bold' css={{ fontSize: theme.font.size.large }}>
          {t('Compose Message')}
        </Text>
        <SelectTemplateButton onSelectTemplate={handleSelectTemplate} />
      </header>
      <MessageTemplate
        draggableTags
        tags={templateTags ?? []}
        initialTemplate={
          selectedTemplate?.templateString || defaultTemplate?.templateString || defaultQuickFillTemplate
        }
        onChange={(template) => setSelectedTemplateString(template)}
        isNewTag
      >
        <div css={containerStyle}>
          <MessageTemplate.Editor />
          <Text size='small' color='subdued'>
            {t('Click a tag below to add it to your message')}
          </Text>
          <MessageTemplate.TagList />
        </div>
      </MessageTemplate>
    </section>
  );
};

const containerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
});
